<template>
    <div>
        <ui-modal v-ref:modal :width="900" :no-padding-body="true" :backdrop-clickable="false">
            <div slot="header">
                <i class="fa fa-send"></i>
                Enviar E-mail
            </div>
            <div>
                <div class="form pseudo-form" v-el:form data-name="form" v-if="!ui.sent">
                    <ui-loading :state="ui.loading" padding="15px" text="Carregando informações...">
                        <div height="500px" :always="true" style="padding: 15px;" v-el:holder v-slimscroll >
                            <div class="row">
                                <div class="col-md-6">
                                    <customer-picker
                                        v-if="!fixedCustomer"
                                        :model.sync="form.customerId"
                                        :has-label="true"
                                        :allow-creation="false"
                                        placeholder="Pesquisar Cliente"
                                        item-name="Cliente"></customer-picker>
                                    <div v-if="customer && fixedCustomer">
                                        <form-fake-text :model.sync="customer.name" :disabled="true" label="Cliente"></form-fake-text>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="customer && customer.emails.length > 1">
                                    <form-select label="Esse cliente possui mais de 1 e-mail, selecione 1."
                                                 :options="customer.emails"
                                                 identifier="id"
                                                 display="email"
                                                 :model.sync="form.email"></form-select>
                                </div>
                                <div class="col-md-6" v-if="customer && customer.emails.length === 1">
                                    <form-select label="E-mail"
                                                 :disabled="true"
                                                 :options="customer.emails"
                                                 identifier="id"
                                                 display="email"
                                                 :model.sync="form.email"></form-select>
                                </div>
                            </div>
                            <div>
                                <form-text label="Assunto"
                                           v-if="customer"
                                           :model.sync="form.subject"
                                           :placeholder="buildSubject"></form-text>
                            </div>
                            <div>
                                <form-editor label="Mensagem"
                                             :model.sync="form.message"
                                             :allow-links="false"
                                             :allow-images="false"></form-editor>
                            </div>
                            <div>
                                <h4>Imóveis selecionados</h4>
                                <div class="alert alert-warning" v-if="ui.originalIds.length > 5">
                                    <i class="fa fa-exclamation"></i>
                                    <span>Você só pode selecionar no máximo 5 imóveis.</span>
                                </div>
                                <div class="alert alert-warning" v-if="ui.propertiesWithoutPhoto.length > 0">
                                    <i class="fa fa-exclamation"></i>
                                    <span v-if="ui.propertiesWithoutPhoto.length > 1">
                                        Os imóveis {{ codes(ui.propertiesWithoutPhoto) }} não possuem fotos e não podem ser enviados
                                    </span>
                                    <span v-if="ui.propertiesWithoutPhoto.length === 1">
                                        O imóvel {{ codes(ui.propertiesWithoutPhoto) }} não possui fotos e não pode ser enviado
                                    </span>
                                </div>
                                <table class="table">
                                    <tbody>
                                        <tr v-for="property in form.properties">
                                            <td style="position: relative; width: 76px;">
                                                <property-media :property.sync="property" width="60px"></property-media>
                                            </td>
                                            <td>
                                                <span>{{ property.lines.first }}</span>
                                            </td>
                                            <td>
                                                <div v-if="property.websites.length > 1">
                                                    <form-select label="Website"
                                                                 :options="property.websites"
                                                                 identifier="id"
                                                                 display="user_domain"
                                                                 :model.sync="property.website"></form-select>
                                                </div>
                                            </td>
                                            <td v-if="form.properties.length > 1" @click="removeProperty(property)">
                                                <button class="btn btn default">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ui-loading>
                </div>
                <div v-if="ui.sent" style="padding: 30px;">
                    <div class="text-center">
                        <img src="/assets/imgs/img-ok.png" width="150">
                    </div>
                    <h2 class="text-center">
                        <span>E-mail enviado!</span>
                    </h2>

                    <div style="display: flex; justify-content: center; text-align: center; line-height: 40px">
                        <div v-if="response.form_status === 'created'">
                            <div>Um <b>novo negócio</b> foi criado e o e-mail foi registrado</div>
                            <div><a target="_blank" :href="'/forms/' + response.form_id" class="btn blue">ver negócio</a></div>
                        </div>

                        <div v-if="response.form_status === 'updated'">
                            <div>O e-mail foi registrado no negócio</div>
                            <div><a target="_blank" :href="'/forms/' + response.form_id" class="btn blue">ver negócio</a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button class="btn btn-default" type="button" @click="hideModal">Fechar</button>
                <button class="btn btn-primary" type="button" @click="sendEmail" :disabled="ui.sending" v-if="!ui.sent">Enviar
                    <i class="fa fa-send"></i>
                </button>
            </div>
        </ui-modal>
    </div>
</template>
<script type="text/javascript">
    const Promise = require('bluebird')
    const R = require('ramda')
    const { client, vueChaos } = require('sci/helpers')
    const Validator = require('sci/helpers/validator')

    const validator = new Validator({
        'rules': {
            'email': 'required',
            'customerId': 'required'
        },
        'messages': {
            'customerId.required': 'Campo obrigatório'
        },
        'attributes': {}
    })

    const defaultUi = {
        selectedCustomer: null,
        originalIds: [],
        loading: false,
        sending: false,
        sent: false,
        propertiesWithoutPhoto: []
    }

    const defaultForm = {
        email: null,
        customerId: null,
        message: null,
        // customer: {"id":12,"code":12,"name":"Anderson Paulo das Dores Neto","status":1},
        properties: []
    }

    export default{
        props: {
            profile: {
                default: null
            },
            sent: {
                type: Function,
                default: null
            },
            fixedCustomer: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                ui: R.clone(defaultUi),
                form: R.clone(defaultForm),
                customer: null,
                from: null,
                fromId: null,
                response: null
            }
        },
        methods: {
            codes (properties) {
                return properties.map(_ => _.user_code).join(' - ')
            },
            show (ids = [], customerId = null, from = null, fromId = null) {
                if (!Array.isArray(ids)) {
                    throw new Error('ids must be array.')
                }

                this.ui.originalIds = ids

                this.ui.loading = true

                this.from = from
                this.fromId = fromId

                this.$refs.modal.show()

                const jobs = {
                    propertiesRes: [],
                    customerRes: null
                }

                if (ids.length) {
                    jobs.propertiesRes = client.post('Carregando imóveis...', '/properties/search', {
                        ids
                    })
                }

                if (customerId) {
                    jobs.customerRes = client.get('Carregando cliente...', `/customers/${customerId}`)
                }

                Promise.props(jobs).then(({ customerRes, propertiesRes }) => {
                    const customer = customerRes ? customerRes.data : null
                    const properties = propertiesRes ? propertiesRes.data : []

                    if (customer) {
                        this.customer = customer
                        this.form.customerId = customer.id
                    } else {
                        this.customer = null
                        this.form.customerId = null
                    }

                    this.ui.propertiesWithoutPhoto = properties
                        .filter((property) => property.photos && property.photos.length < 1)

                    this.form.properties = properties
                        .filter((property) => property.photos && property.photos.length > 0)
                        .slice(0, 5)
                        .map((property) => {
                            return { ...property, website: R.pathOr(null, ['websites', 0, 'id'], property) }
                        })
                }).finally(() => {
                    this.ui.loading = false
                })
            },
            hideModal () {
                this.$refs.modal.hide().then(() => {
                    this.ui = R.clone(defaultUi)
                    this.form = R.clone(defaultForm)
                })
            },
            removeProperty (property) {
                this.form.properties.$remove(property)
            },
            sendEmail () {
                this.ui.sending = true

                validator
                    .validateForm(this.$els.form, this.form)
                    .then(() => {
                        return client
                            .silent()
                            .block(this.$els.holder)
                            .post('Enviando...', `/customers/${this.form.customerId}/email-properties`, {
                                from: this.from,
                                from_id: this.fromId,
                                message: this.form.message,
                                subject: this.form.subject || '',
                                email: this.form.email,
                                properties: this.form.properties.map((property) => ({
                                    propertyId: property.id,
                                    websiteId: property.website
                                }))
                            })
                            .then(vueChaos(this.$els.form))
                            .then((res) => {
                                this.ui.sent = true

                                if (this.sent) {
                                    this.sent()
                                }

                                this.response = res
                            })
                    })
                    .finally(() => {
                        this.ui.sending = false
                    })
            },
            customerSelected (id) {
                this.form.customerId = id
                if (id !== null) {
                    client.get('Carregando cliente...', `/customers/${id}`).then((res) => {
                        this.customer = res.data
                    })
                } else {
                    this.customer = null
                }
            }
        },
        watch: {
            'form.customerId' (newVal) {
                this.customerSelected(newVal)
            },
            customer (newVal, oldVal) {
                if (newVal && Array.isArray(newVal.emails)) {
                    if (newVal.emails.length > 0) {
                        this.form.email = newVal.emails[0].id
                    }
                }
            }
        },
        computed: {
            buildSubject () {
                if (this.customer) {
                    return `Padrão: 🏠 Olá ${this.customer.name}, separamos estes imóveis que encaixam-se perfeitamente no seu perfil! 🏠`
                }

                return null
            }
        },
        ready () {
            this.$refs.modal.$on('hide', () => {
                this.$emit('closed')
            })
        }
    }
</script>



// WEBPACK FOOTER //
// MailPropertiesModal.vue?356ed662